import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ecommerceBaseUrl } from "network";

export const brandSlice = createApi({
    reducerPath: "brandSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: ecommerceBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getBrands: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/brand?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addBrands: builder.mutation({
            query: (body) => ({
                url: "/brand",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateBrands: builder.mutation({
            query: ({ id, body }) => ({
                url: `/brand/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteBrands: builder.mutation({
            query: (id) => ({
                url: `/brand/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetBrandsQuery,
    useAddBrandsMutation,
    useUpdateBrandsMutation,
    useDeleteBrandsMutation
} = brandSlice;
